import { Handle, HandleProps } from "@xyflow/react";

type Props = HandleProps;

/**
 * A visible connection handle (dot) that users can drag from to create connections to existing nodes.
 * Shows a cyan dot that scales up on hover.
 */
export const ConnectionHandle = (props: Props) => {
    return (
        <Handle
            {...props}
            className="!bg-cyan-400 hover:!bg-cyan-500 !transition-all !duration-200"
            style={{
                width: 10,
                height: 10,
                border: "2px solid white",
                boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
            }}
        />
    );
};
